/*
 *                     NOTICE
 *            COPYRIGHT 2018 Ab Initio
 *       UNPUBLISHED -- ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

export let Orientation = /*#__PURE__*/function (Orientation) {
  Orientation["HORIZONTAL"] = "horizontal";
  Orientation["VERTICAL"] = "vertical";
  return Orientation;
}({});
export let Alignment = /*#__PURE__*/function (Alignment) {
  Alignment["CENTER"] = "center";
  Alignment["LEFT"] = "left";
  Alignment["RIGHT"] = "right";
  Alignment["TOP"] = "top";
  Alignment["BOTTOM"] = "bottom";
  return Alignment;
}({});
export let HorizontalAlignment = /*#__PURE__*/function (HorizontalAlignment) {
  HorizontalAlignment["CENTER"] = "center";
  HorizontalAlignment["LEFT"] = "left";
  HorizontalAlignment["RIGHT"] = "right";
  return HorizontalAlignment;
}({});
export let VerticalAlignment = /*#__PURE__*/function (VerticalAlignment) {
  VerticalAlignment["MIDDLE"] = "middle";
  VerticalAlignment["TOP"] = "top";
  VerticalAlignment["BOTTOM"] = "bottom";
  return VerticalAlignment;
}({});
export let Direction = /*#__PURE__*/function (Direction) {
  Direction["UP"] = "up";
  Direction["DOWN"] = "down";
  Direction["LEFT"] = "left";
  Direction["RIGHT"] = "right";
  return Direction;
}({});

/**
 * An enumeration of selection modes.
 */
export let SelectionMode = /*#__PURE__*/function (SelectionMode) {
  SelectionMode["SINGLE"] = "single";
  SelectionMode["MULTIPLE"] = "multiple";
  SelectionMode["NONE"] = "none";
  return SelectionMode;
}({});
export let ResizeDirection = /*#__PURE__*/function (ResizeDirection) {
  ResizeDirection["TOP"] = "top";
  ResizeDirection["TOP_LEFT"] = "top-left";
  ResizeDirection["TOP_RIGHT"] = "top-right";
  ResizeDirection["BOTTOM"] = "bottom";
  ResizeDirection["BOTTOM_LEFT"] = "bottom-left";
  ResizeDirection["BOTTOM_RIGHT"] = "bottom-right";
  ResizeDirection["LEFT"] = "left";
  ResizeDirection["RIGHT"] = "right";
  return ResizeDirection;
}({});
export let PageOrientation = /*#__PURE__*/function (PageOrientation) {
  PageOrientation["Landscape"] = "landscape";
  PageOrientation["Portrait"] = "portrait";
  return PageOrientation;
}({});

// TODO Remove because this causes all sorts of difficult type conversion issues
//# sourceMappingURL=SharedTypes.js.map
